function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

import { getApiBaseUrl } from './apiBase';
const API_BASE_URL = getApiBaseUrl();

export const pushService = {
  isSupported() {
    return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  },
  async getPublicKey() {
    const res = await fetch(`${API_BASE_URL}/push/publicKey`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.msg || 'Failed to get public key');
    return data.publicKey;
  },

  async registerSw() {
    if (!('serviceWorker' in navigator)) throw new Error('Service workers not supported');
    const reg = await navigator.serviceWorker.register('/sw.js');
    return reg;
  },

  async subscribe(email) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      throw new Error('Push not supported');
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') throw new Error('Notification permission denied');

    const reg = await this.registerSw();
    const publicKey = await this.getPublicKey();
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });

    const token = localStorage.getItem('token');
    const res = await fetch(`${API_BASE_URL}/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email, subscription: sub }),
    });
    const data = await res.json();
    if (!res.ok || !data.success) throw new Error(data.msg || 'Failed to save subscription');
    return sub;
  },

  async unsubscribe(email) {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return false;

    const token = localStorage.getItem('token');
    await fetch(`${API_BASE_URL}/push/unsubscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ email, endpoint: sub.endpoint }),
    });

    await sub.unsubscribe();
    return true;
  },

  async initForEmail(email) {
    if ('Notification' in window && Notification.permission === 'denied') {
      return false;
    }
    try {
      await this.subscribe(email);
      return true;
    } catch (err) {
      if ((err?.message || '').toLowerCase().includes('permission denied')) {
        return false;
      }
      console.warn('Push init failed:', err);
      return false;
    }
  },

  async send(title, body, url, data) {
    const token = localStorage.getItem('token');
    const user = (() => {
      try { return JSON.parse(localStorage.getItem('user') || 'null'); } catch { return null; }
    })();
    if (!user || !user.email) throw new Error('User email not available');
    const payload = { email: user.email, title, body, url, data };
    const res = await fetch(`${API_BASE_URL}/push/send`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.success) throw new Error(json.msg || 'Failed to send push');
    return json;
  },
};
